export enum STODocumentListRowAction {
  SET_ARRIVED = 'set_arrived',
  RETRY_NS_FULFILL = 'retry_ns_fulfill',
}
